import CryptoJs from 'crypto-js';

const aes = {
    encrypt(data) {
        const key = CryptoJs.enc.Utf8.parse(process.env.VUE_APP_KEY); // 16 bytes key
        const iv = CryptoJs.enc.Utf8.parse(process.env.VUE_APP_IV); // 16 bytes IV
        const encrypted = CryptoJs.AES.encrypt(data, key, {
            iv: iv,
            mode: CryptoJs.mode.CBC,
            padding: CryptoJs.pad.Pkcs7
        });
        return encrypted.toString();
    }
};
export default aes;
